import "owl.carousel";

jQuery(document).ready(function ($) {
  if ($(".hero-banner").length > 0) {
    $(".hero-banner").owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      singleItem: true,
      autoplay: true,
    });
  }

  if ($(".js-focus-our-client_rates").length > 0) {
    var clientWrapper = $(".js-focus-our-client_rates");
    clientWrapper.removeClass("row").addClass("owl-carousel");
    clientWrapper.find(".col").removeClass("col col-lg col-md-6 col-12");
    clientWrapper.owlCarousel({
      loop: true,
      nav: false,
      items: 1,
      margin: 20,
      autoplay: true,
      responsive: {
        768: {
          items: 2,
        },
        992: {
          items: 3,
        },
      },
    });
  }
});
